import { mapState } from 'vuex';
import get from 'lodash/get';
import { getContrastYIQ, themesMixin } from '@/utils/themes';
export default {
  name: 'SearchOperatorToggle',
  mixins: [themesMixin],
  props: {
    operatorOptions: {
      type: Array,
      required: true,
      default: () => []
    },
    operator: {
      type: String,
      default: 'AND'
    },
    small: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      joinIndex: 0
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    textColor() {
      return getContrastYIQ(this.vuetifyColorHex());
    }
  },
  watch: {
    joinIndex(value) {
      const selectedOperator = get(this.operatorOptions, `[${value}].value`, 'AND');
      this.$emit('operator-change', selectedOperator);
    },
    operator: {
      handler(value) {
        this.joinIndex = this.operatorOptions.findIndex(option => option.value === value);
      },
      immediate: true
    }
  },
  methods: {}
};